/**
 * Account-configured default currency (settings), with EUR fallback.
 */
export function accountCurrency(account) {
  return (
    account?.settings?.default_currency ||
    account?.default_currency ||
    'EUR'
  );
}

/**
 * Prefer breakdown/rate currency, then account default.
 */
export function resolvePriceCurrency({
  breakdownCurrency,
  rateCurrency,
  account,
} = {}) {
  return (
    breakdownCurrency ||
    rateCurrency ||
    accountCurrency(account)
  );
}

/**
 * Format a money amount. Returns null when amount is missing or zero
 * (cards should not show a price of 0).
 */
export function formatMoney(
  amount,
  currency = 'EUR',
  { hideZero = true, maximumFractionDigits = 0, locale } = {}
) {
  if (amount == null || amount === '') return null;
  const value = Number(amount);
  if (Number.isNaN(value)) return null;
  if (hideZero && value === 0) return null;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || 'EUR',
    maximumFractionDigits,
  }).format(value);
}
